import styled from 'styled-components';

const TokenPnlWidgetStyled = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export default TokenPnlWidgetStyled;
